import { gql } from "@apollo/client";
import { DEDUCTION_FRAGMENT } from "./deductionFragment";

const DELETE_DEDUCTION_DOCUMENTS = gql`
  ${DEDUCTION_FRAGMENT}
  mutation DeleteDeductionDocuments($params: DeleteDeductionDocumentsParams!) {
    deleteDeductionDocuments(params: $params) {
      ...DeductionFields
    }
  }
`;

export default DELETE_DEDUCTION_DOCUMENTS;
